/**
 * IN ACTIVE DEVELOPMENT
 *
 * Please note that this new workflow schema is under active development, tracked by this work item:
 *
 * https://office.visualstudio.com/DefaultCollection/ISS/_workitems/edit/4849590
 *
 * It is not yet supported for general use, please contact PBaer and YutYe if you are interested in piloting.
 */
/**
 * Whether an item functions as an input item (provided to the workflow) or an output item (an annotation produced by
 * the workflow).
 */
export var ItemRole;
(function (ItemRole) {
    ItemRole[ItemRole["Input"] = 1] = "Input";
    ItemRole[ItemRole["Output"] = 2] = "Output";
})(ItemRole || (ItemRole = {}));
/**
 * Cardinality of workflow model items. Positive numbers are reserved for exact counts.
 */
export var ItemCardinality;
(function (ItemCardinality) {
    ItemCardinality[ItemCardinality["Single"] = 1] = "Single";
    ItemCardinality[ItemCardinality["Any"] = -1] = "Any";
    ItemCardinality[ItemCardinality["Optional"] = -2] = "Optional";
    ItemCardinality[ItemCardinality["Some"] = -3] = "Some"; // At least one
})(ItemCardinality || (ItemCardinality = {}));
//# sourceMappingURL=workflow-model-schema.js.map